export default __webpack_public_path__ + "static/m-news-0764aa4169273ac2d7b1d01047992764.jpg";